'use client';

import { useLocalStorage } from '@larvitu/shared/react/hooks';
import { createContext } from 'react';

import { defaultSettings } from '../config';
import { colorPresets, getColorPresets } from '../utils/getColorPresets';

import type { SettingsContextProps } from '../@types/settings';
import type React from 'react';
import type { ReactNode } from 'react';

// ----------------------------------------------------------------------

const initialState: SettingsContextProps = {
  ...defaultSettings,
  onToggleMode: () => void 0,
  onToggleDirection: () => void 0,
  onChangeColorPresets: () => void 0,
  onResetSetting: () => void 0,
  // setColor: { name: '', ...colorPresets[0] },
  colorOption: [],
};

export const SettingsContext = createContext( initialState );

interface Props {
  children: ReactNode;
}

export const SettingsProvider = ({ children }: Props): JSX.Element => {
  const [settings, setSettings] = useLocalStorage( 'settings', {
    ...defaultSettings,
  } );

  const onToggleMode = (): void => {
    setSettings( {
      ...settings,
      themeMode: settings.themeMode === 'light' ? 'dark' : 'light',
    } );
  };

  const onToggleDirection = (): void => {
    setSettings( {
      ...settings,
      themeDirection: settings.themeDirection === 'ltr' ? 'rtl' : 'ltr',
    } );
  };

  const onChangeColorPresets = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setSettings( {
      ...settings,
      themeColorPresets: event.target as HTMLInputElement['value'],
    } );
  };

  const onResetSetting = (): void => {
    setSettings( { ...defaultSettings } );
  };

  return (
    <SettingsContext.Provider
      value={{
        ...settings,
        // Mode
        onToggleMode,

        // Direction
        onToggleDirection,

        // Color Presets
        onChangeColorPresets,
        // setColor: getColorPresets( settings.themeColorPresets ),
        // TODO: inject colorPresets
        // colorOption: colorPresets.map((color) => ({
        //   title: color.title,
        //   primary: color.primary.main,
        //   secondary: color.secondary.main,
        // })),

        // Reset Setting
        onResetSetting,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};
